import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'

export const getCorpCoverageThunk = createAsyncThunk(
  'financialAnalysis/Corp/getCorpCoverage',
  async (data, { rejectWithValue }) => {
    const response = await FinancialAnalysisService.getCoverage(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadCorpCoverage = createAsyncThunk(
  'financialAnalysis/Corp/downloadCorpCoverage',
  async (data) => {
    const response = await FinancialAnalysisService.downloadCoverage(data)
    handleExport(response.data, response.filename)
  },
)
